import React, { useState } from "react";
import AddMoney from "../childScreens/addMoney";
import { globalStyle } from "../../../assets/GlobalStyle/globalStyle";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import Colors from "../../../assets/Color/Colors";
import WithDrawMoney from "../childScreens/withDrawMoney";
import { globalFontStyle } from "../../../assets";
import { useNavigation } from "@react-navigation/native";
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import {globalConst} from "../../../utils/globalConstant";
import PartnerWalletModal from "./PartnerWalletModal";

const WebWallet = ({ rechargeAmount, conversionMessage }) => {
  const [isDepositEnable, setIsDepositEnable] = useState(true);
  const navigation = useNavigation();

  const onToggle = (param) => {
    setIsDepositEnable(param);
  };
  return (
    <View style={[globalStyle.desktopRightBox]}>
        {globalConst.partnerId === 1 ? (
            <>
                <View
                    style={{
                        flexDirection: "row",
                        //paddingVertical: 20,
                        borderBottomWidth: 0.5,
                        borderBottomColor: "rgba(0, 0, 0, 0.3)",
                        paddingHorizontal: 15,
                        marginBottom: 10,
                    }}
                >
                    <FormTextLabel
                        labelStyles={[
                            isDepositEnable
                                ? styles.selectedFormTypeBlock
                                : styles.unSelectedFormTypeBlock,
                        ]}
                        onPress={() => {
                            onToggle(true);
                        }}
                        label={'Deposit'}
                    />
                    <FormTextLabel
                        labelStyles={[
                            isDepositEnable
                                ? styles.unSelectedFormTypeBlock
                                : styles.selectedFormTypeBlock,
                        ]}
                        onPress={() => {
                            onToggle(false);
                        }}
                        label={'Withdraw'}
                    />
                </View>
            {isDepositEnable ? (
                    <AddMoney
                        rechargeAmountEvent={rechargeAmount}
                        navigation={navigation}
                    />
                ) : (
                    <WithDrawMoney navigation={navigation} />
                )}
            </>
            )
            : (<PartnerWalletModal
                onBtnClick={() => {}}
                conversionMessage={conversionMessage} />)
        }
    </View>
  );
};

export default WebWallet;

const styles = StyleSheet.create({
  selectedFormTypeBlock: {
    ...globalFontStyle.appFontHeading,
    paddingHorizontal: 10,
    borderBottomWidth: 2,
    paddingBottom: 12,
    paddingTop: 10,
    borderBottomColor: Colors.black,
  },
  unSelectedFormTypeBlock: {
    ...globalFontStyle.appFontHeadingRegular,
    paddingHorizontal: 10,
    borderBottomWidth: 2,
    paddingBottom: 14,
    paddingTop: 10,
    borderBottomColor: Colors.bgWhite,
  },
});
